<template>
  <div class="tour-lf">
    <vue-headful title="Tour LF - FF Pfaffenhofen"/>
    <Header :menu-at="0" headerTitle="Fahrzeuge - Rundgang LF"/>
    <div class="dynamic-space"></div>
    <div class="dynamic-space"></div>
    <div class="container header-container">
      <router-link to="fahrzeug" class="uppercase">
        <font-awesome-icon icon="arrow-left" /> &nbsp;
        Zurück zur Übersicht
      </router-link>
      <h1>Fahrzeuge > Löschgruppenfahrzeug (LF)</h1>
      <p>Das LF16/12 ist auf einem Mercedes Benz Fahrgestell “Atego 1428” durch die Firma Ziegler aufgebaut und hat mit seiner Gesamtmasse von 14t eine Motorleistung von 280PS. Im Inneren können 9 Feuerwehrleute Platz nehmen und 2 Feuerwehrleute können sich bereits während der Anfahrt mit einem Atemschutzgerät ausrüsten. Die Ausstattung des Fahrzeuges umfasst alle Einsatzgebiete die es abzudecken gilt. Vom Brandeinsatz über die technische Hilfeleistung bis hin zu Hochwasser oder Sturm Einsätzen alles hat seinen Platz im Aufbau gefunden. Zusätzlich im Aufbau befindet sich ein 1600l Wassertank ein 120l Schaumtank und eine fest verbaute Schaumzumischanlage um schnell Löschschaum zu erzeugen.
      </p>

      <div class="dynamic-space"></div>
      <h2>Fahrzeug Tour</h2>
      <p>
        Die Fahrzeugtour bietet Ihnen einen digitalen Rundgang um unsere Fahrzeuge. 
        Nutzen Sie die 
        <span class="example-button">
          <font-awesome-icon icon="search"></font-awesome-icon>
        </span> 
        Buttons um durch das Fahrzeug und seine Ausrüstung zu navigieren. Der 
        <span class="example-button">
          <font-awesome-icon icon="arrow-down"></font-awesome-icon>
        </span> 
        Button bringt Sie immer zum vorherigen Punkt der Tour.
        <br><br>
        Über die folgenden vier Buttons lässt zusätzlich sich die Seitenansicht des Fahrzeugs steuern.
      </p>

      <div class="sideview-flex-row">
        <div class="side-button" v-bind:class="{active: activeSide[0]}" >
          <button @click="changeActiveSide(0)" 
            v-tooltip.bottom-start="{delay: 100, content: 'Beifahrerseite'}">
            <img v-if="activeSide[0]" src="icons/sideview_right_active.svg" width="100%">
            <img v-if="!activeSide[0]" src="icons/sideview_right.svg" width="100%">
          </button>
        </div>
        <div class="side-button" v-bind:class="{active: activeSide[1]}">
          <button @click="changeActiveSide(1)" 
            v-tooltip.bottom-start="{delay: 100, content: 'Fahrerseite'}">
          <img v-if="activeSide[1]" src="icons/sideview_left_active.svg" width="100%">
          <img v-if="!activeSide[1]" src="icons/sideview_left.svg" width="100%">
          </button>
        </div>
        <div class="side-button" v-bind:class="{active: activeSide[2]}">
          <button @click="changeActiveSide(2)" 
            v-tooltip.bottom-start="{delay: 100, content: 'Rückseitensicht'}">
          <img v-if="activeSide[2]" src="icons/backview_active.svg" width="100%">
          <img v-if="!activeSide[2]" src="icons/backview.svg" width="100%">
          </button>
        </div>
        <div class="side-button" v-bind:class="{active: activeSide[3]}">
          <button @click="changeActiveSide(3)" 
            v-tooltip.bottom-start="{delay: 100, content: 'Frontansicht'}">
          <img v-if="activeSide[3]" src="icons/frontview_active.svg" width="100%">
          <img v-if="!activeSide[3]" src="icons/frontview.svg" width="100%">
          </button>
        </div>
      </div>

      <div class="tour-container">
        <div class="image-container">
          <img :src="active.img_url" width="85%" draggable="false">
          <div class="buttons">
            <button v-for="(link, index) in active.links" :key="index"
                    v-bind:style="link.position" @click="changeActive(link.target_id)">
                <font-awesome-icon :icon="link.symbol" />
            </button>
          </div>
        </div>
      </div>

      <div class="dynamic-space"></div>

      <h2>Andere Fahrzeuge</h2>
      <p>Die Fahrzeug-Touren für die zwei anderen Fahrzeuge der Feuerwehr Pfaffenhofen finden Sie hier:</p>
      <div class="flex-container other-vehicles">
        <div class="card card-tlf" @mouseenter="toggleTLF()" @mouseleave="toggleTLF()">
          <div class="start-icon">
            <font-awesome-icon @click="changeRoute('hlf')" icon="play-circle" />
          </div>
          <div class="card-suptitle" v-show="hoverTLF">HLF20</div>
          <div class="card-title" v-show="hoverTLF">Hilfeleistungslöschfahrzeug </div>
        </div>
        <div class="card card-mzf" @mouseenter="toggleMZF()" @mouseleave="toggleMZF()">
          <div class="start-icon">
            <font-awesome-icon @click="changeRoute('mzf')" icon="play-circle" />
          </div>
          <div class="card-suptitle" v-show="hoverMZF">MZF</div>
          <div class="card-title" v-show="hoverMZF">Mehrzweckfahrzeug</div>
        </div>
      </div>
    </div>
    
  <Footer />
  <Scroll2Top />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'
import tourData from '@/views/json/lf.json'

export default {
  name: 'tour_lf',
  components: {
    Header, Footer, Scroll2Top
  },
  data() {
    return {
      activeSide: [true, false, false, false],
      tourData: tourData,
      activeState: 0,
      active: tourData[0],
      hoverLF: false,
      hoverTLF: false,
      hoverMZF: false
    }
  },
  methods: {
    changeActiveSide(sideId) {
      this.activeSide = [false, false, false, false]
      this.activeSide[sideId] = true

      const startIdxes = [0, 10, 24, 23]
      this.active = this.tourData[startIdxes[sideId]]
    },
    changeActive(targetId) {
      this.active = this.tourData[targetId]
    },
    toggleLF() {
      this.hoverLF = !this.hoverLF
    },
    toggleTLF() {
      this.hoverTLF = !this.hoverTLF
    },
    toggleMZF() {
      this.hoverMZF = !this.hoverMZF
    },
    changeRoute(location) {
      let newRoute = "tour_" + location 
      this.$router.push(newRoute)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/theme.scss";

.header-container {
  //padding-top: 100px;

  a {
      text-decoration: none;
      color: $dark;
      font-weight: bold;
  }

  a:hover {
      color: $primary;
  }

  p {
    color: rgba(0,0,0,.75);
    line-height: 26px;
  }

  .uppercase {
    text-transform: uppercase;
    font-size: 14px;
  }
}

.example-button {
  margin: 0px 4px;
  color: white;
  background: $dark;
  padding: 4px 6px;
  border-radius: 100%;
  font-size: 10px;
}

.dynamic-space {
  margin: 50px 0px;
}

.sideview-flex-row {
  display: flex;
  justify-content: center;
  cursor: pointer;

  .side-button {
    width: 160px;
    user-select: none;
    border: 2px dashed rgba(0,0,0,.8);
    border-radius: 10px;
    margin: 0px 5px;

    @include tablet {
      margin: 0px 25px;
    }
  }

  .active {
     border: 2px dashed $primary;
     background: rgba($primary, 0.05);
  }

  button {
    width: 100%;
    height: 100%;
    background: none;
    border: none;
    cursor: pointer;
  }

}

.tour-container {
  margin-top: 10px;

  .image-container {
    position: relative;

    img {
      height: 80%;
      display: block;
      margin: auto;

      pointer-events: none;
      user-select: none;
    }

  button {
    position: absolute;
    background: black;
    box-shadow:$shadow-medium;
    border: none;
    width: 22px;
    height: 22px;
    border-radius: 100%;
    color: $light-0;
    cursor: pointer;
    font-size: 8px;
    border: 1px solid $light-0;

    @include mini {
      width: 34px;
      height: 34px;
      font-size: 10px;
      border: 2px solid $light-0;
    }

    @include tablet {
      width: 46px;
      height: 46px;
      font-size: 14px;

    }

    &:hover {
      color: $primary;
    }
  }
  }
}

/////////////////////////////////////////////////////
/////////////////////////////////////////////////////


.other-vehicles {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  margin: 30px 0px 10px 0px;

    
  .card {
    width: 320px;
    height: 220px;
    margin: 20px 10px;
    background: $light-0;
    box-shadow: $shadow-medium;
    border-radius: 10px;
    transition: all 0.2s;
    cursor: pointer;
    position: relative;
  }

  .card-background-lf:hover {
    filter: brightness(40%)
  }

  .card-suptitle {
    color: $primary;
    font-weight: bold;
    position: absolute;
    left: 20px;
    bottom: 40px;
  }


  .card-title {
    color: $light-0;
    font-weight: bold;
    position: absolute;
    left: 20px;
    bottom: 15px;
  }

  .start-icon{
    font-size: 75px;
    color: $light-0;
    width: 100%;

    position: absolute;
    top: 45px;
    text-align: center;
    transition: all 0.5s;
    opacity: 0.3;
  }


  .start-icon:hover, a {
    color: mix($light-0, $primary, 0.4);
    transition: all 0.5s;
    opacity: 1;
  }

  .card-lf {
    background: url(/vehicles/lf1612_d.gif);
    background-size: cover;
    filter: brightness(200%);
  }

  .card-lf:hover {
    filter: brightness(100%);
  }

  .card-tlf {
    background: url(/vehicles/hlf_d.gif);
    background-size: cover;
    filter: brightness(200%);
  }

  .card-tlf:hover {
    filter: brightness(100%);
  }

  .card-mzf {
    background: url(/vehicles/mzf_d.gif);
    background-size: cover;
    filter: brightness(200%);
  }

  .card-mzf:hover {
    filter: brightness(100%);
  }

  .card:hover {
    transition: all 0.2s;
  }

}



////////////////////////////////////////////////////
////////////////////////////////////////////////////

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgba(0, 0, 0, 0.8);;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

</style>